const { AppConfig } = require('../config')

export class Singleton {
    private static instance: Singleton;
    public dataPromise: Promise<any>;
    public dataResolve: (values?:any ) => void;

    private constructor() {
    }

    public static getInstance(): Singleton {
        if (!Singleton.instance) {
            Singleton.instance = new Singleton();
        }
        return Singleton.instance;
    }

 
    public getData():Promise<any> {
        
        if( !this.dataPromise ){
            this.dataPromise = new Promise<any>((resolve, reject) => {
                this.dataResolve = resolve;
                fetch(`${AppConfig.url_backend}/forms/properties`)
                .then(response=> response.json())
                .then(data=> { 
                    console.log("data ", data?.body?.body );                    
                  this.dataResolve(data?.body.body); 
                })
                .catch(error=> reject(error))
            })
        }

        return this.dataPromise;
        
    }

}
